import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authAxios } from "../framework/api";
import { loginTokenKey, setItem } from "../utils/localStorage";
import { AuthStateContext } from "../contexts/AuthStateContext";
import { CURRENTROUTE } from "../contexts/SaveDataContext";

const NaverLogin = () => {
  const { handleChangeAuthState } = useContext(AuthStateContext);
  const navigate = useNavigate();
  const naverRef = useRef(null);
  const [sdkLoaded, setSdkLoaded] = useState(false);

  // SDK 로드
  useEffect(() => {
    if (!document.getElementById("naver-login-sdk")) {
      const naverScript = document.createElement("script");
      naverScript.id = "naver-login-sdk";
      naverScript.src =
        "https://static.nid.naver.com/js/naveridlogin_js_sdk_2.0.2.js";
      naverScript.type = "text/javascript";
      naverScript.async = true;
      naverScript.onload = () => {
        setSdkLoaded(true);
      };
      naverScript.onerror = () => {
        console.error("Naver SDK 로드 오류");
        window.location.reload();
      };
      document.head.appendChild(naverScript);
    } else {
      setSdkLoaded(true);
    }
  }, []);

  // SDK와 div가 모두 준비된 후에만 init
  useEffect(() => {
    if (sdkLoaded && naverRef.current && window.naver) {
      const naverLogin = new window.naver.LoginWithNaverId({
        clientId: process.env.REACT_APP_NAVER_KEY,
        callbackUrl: `${process.env.REACT_APP_ROOT_URL}/login`,
        isPopup: false,
        loginButton: { color: "green", type: 3, height: 30 },
      });
      naverLogin.init();
      naverLogin.getLoginStatus((status) => {
        if (status) {
          authAxios
            .post(`/mobile/auth/social`, {
              type: "naver",
              socialId: naverLogin.user.id,
              email: naverLogin.user.email,
            })
            .then((socialLogin) => {
              setItem(loginTokenKey, socialLogin.data);
              handleChangeAuthState(true);
              // 세션 스토리지에 저장된 sessionSaveData 정보를 가져온다.
              const sessionSaveData = sessionStorage.getItem("sessionSaveData");
              if (sessionSaveData) {
                const parsedData = JSON.parse(sessionSaveData);
                if (parsedData.route === CURRENTROUTE.DEFAULT) {
                  // 파싱된 데이터를 url?파라미터로 넘겨준다.
                  const { route, ...rest } = parsedData;
                  console.log("메인페이지", rest);
                  navigate(`/?${new URLSearchParams(rest).toString()}`);
                } else if (parsedData.route === CURRENTROUTE.COMPATIBLE) {
                  // 파싱된 데이터를 url?파라미터로 넘겨준다.
                  const { route, ...rest } = parsedData;
                  // 성별이 여자인경우 모든 url 파라미터 앞에 언더바가 붙음.
                  // ex _gender=female&_yearMonthDay=19990101&_hourMin=1234
                  // 파싱된 데이터에서 성별이 여자인경우 모든 url 파라미터 앞에 언더바가 붙음.
                  // 파싱된 데이터에서 성별이 남자인 경우 언더바 없이 url 파라미터로 넘겨준다.
                  const { gender, ...rest2 } = rest;
                  if (gender === "FEMALE") {
                    rest2.gender = "_" + rest2.gender;
                    rest2.yearMonthDay = "_" + rest2.yearMonthDay;
                    rest2.hourMin = "_" + rest2.hourMin;
                    console.log("궁합페이지 여성", rest2);
                    navigate(
                      `/compatible?${new URLSearchParams(rest2).toString()}`
                    );
                  } else {
                    console.log("궁합페이지 남성", rest);
                    navigate(
                      `/compatible?${new URLSearchParams(rest).toString()}`
                    );
                  }
                }
              } else {
                navigate("/", { replace: true });
              }
            })
            .catch((error) => {
              console.error("Naver 로그인 처리 실패", error);
            });
        } else {
          console.log("Naver 로그인 상태 확인 실패");
        }
      });
    }
  }, [sdkLoaded, naverRef]);

  return (
    <div
      ref={naverRef}
      style={{
        width: "180px",
        overflow: "hidden",
        margin: "auto",
      }}
      id="naverIdLogin"
    ></div>
  );
};

export default NaverLogin;
